export const formatFileSize = (bytes) => {
	if (bytes === 0) {
		return '0 Bytes';
	}
	const sizes = ['Bytes', 'KB', 'MB', 'GB'];
	const index = Math.floor(Math.log(bytes) / Math.log(1024));
	const value = bytes / 1024 ** index;
	return `${Math.round(value * 100) / 100} ${sizes[index]}`;
};

export const escapeHtml = (value) => {
	const map = {
		'&': '&amp;',
		'<': '&lt;',
		'>': '&gt;',
		'"': '&quot;',
		"'": '&#039;',
	};
	return value.replace(/[&<>"']/g, (match) => map[match]);
};
